var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: this.$t("CargoMsg.Cargo_NewTo"),
            width: "380px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { "label-width": "80px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_Carrier") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            companyLob: "seaExport",
                            seaCmp: true,
                            active: true
                          },
                          "default-value": _vm.form.carrierId || "",
                          "callback-params": { key: "carrierId" }
                        },
                        on: {
                          parentCallBack: function(p) {
                            return _vm.getValueFromChild(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: this.$t("CargoMsg.Cargo_BookingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "method-params": { bookingAgent: true },
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "default-value":
                            _vm.form.bookingAgent === 0
                              ? ""
                              : _vm.form.bookingAgent
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.form.bookingAgent = p.cmpIdx)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: this.$t("CargoMsg.Cargo_GenerativeRule") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.form.generativeRule,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "generativeRule", $$v)
                            },
                            expression: "form.generativeRule"
                          }
                        },
                        _vm._l(_vm.generativeRules, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_StartNumber") } },
                    [
                      _c("el-input", {
                        attrs: { no: "starNo" },
                        model: {
                          value: _vm.form.starNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "starNo", $$v)
                          },
                          expression: "form.starNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_EndNumber") } },
                    [
                      _c("el-input", {
                        attrs: { no: "endNo" },
                        on: { change: _vm.endNoChangeHandler },
                        model: {
                          value: _vm.form.endNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "endNo", $$v)
                          },
                          expression: "form.endNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_TotalCopies") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          min: 0,
                          max: 2000,
                          "controls-position": "right"
                        },
                        on: { change: _vm.numberChangeHandler },
                        model: {
                          value: _vm.form.number,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "number", $$v)
                          },
                          expression: "form.number"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: this.$t("CargoMsg.Cargo_AdditionalRemark")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "remark",
                          length: "100",
                          type: "textarea",
                          rows: 3
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.form.generativeRule === _vm.SystemConstants.GENERAL.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: this.$t("CargoMsg.Cargo_ApplicableBranch"),
                            disabled: false
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "branchId",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Office_All,
                              clearable: false,
                              filterable: "",
                              "default-value": _vm.form.branchId || "",
                              cache: false,
                              "static-options": _vm.officeList,
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                return _vm.handleCompany(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.generativeRule ===
                  _vm.SystemConstants.FIXED_LAST_NUMBER.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: this.$t("CargoMsg.Cargo_ApplicableBranch"),
                            disabled: false
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "branchId",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Office_All,
                              clearable: false,
                              filterable: "",
                              disabled: true,
                              "default-value": _vm.form.branchId || "",
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                return _vm.handleCompany(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.generativeRule === _vm.SystemConstants.GENERAL.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: this.$t("CargoMsg.ApplicableDepartment")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "departmentId",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Department,
                              "allow-create": true,
                              filterable: "",
                              cache: false,
                              "static-options": _vm.departmentArray
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.department = p.departmentId
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_Acquirer") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "recipientId",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId
                          },
                          "merge-load": true
                        },
                        on: {
                          change: function(item) {
                            return (_vm.form.userId = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }